String.prototype.validateEmail = function () {
    return this.match(/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/) !== null;
};

String.prototype.ellipsify = function (maxWords) {
    var ret = this.split(" ");

    if (ret.length > maxWords) ret = ret.splice(0, maxWords).join(" ") + "...";
    else ret = ret.join(" ");

    return ret;
};

if (!String.prototype.startsWith) {
    // IE hack
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}

if (console && !console.trace) {
    console.trace = function () {
        console.log("CALL STACK");
        console.log(new Error().stack);
    };
}

(function ($) {
    "use strict";

    /**
     * API invocation
     */
    function _invoke(path, d, c) {
        d = d ? d : {};

        $.ajax({
            cache: false,
            url: path,
            type: "GET",
            dataType: "json",
            data: d,
            success: function (r, s, x) {
                if (c) {
                    c(r);
                }
            },
            error: function (x, s, e) {
                if (c) {
                    c({
                        success: false,
                        message: e,
                    });
                }
            },
        });
    }

    window.PHI = window.PHI || {};

    PHI.api = {
        PAGE_SIZE: 10,
        PAGE_SIZE_NRC_HUB: 10,
        PAGE_SIZE_EXPERTS: 30,
        URL_SEARCH_CASE_STUDIES: "/wp-json/phi/v1/search_case_studies?",
        URL_SEARCH_EXPERTS: "/wp-json/phi/v1/search_experts?",
        URL_SEARCH_BOARD: "/wp-json/phi/v1/search_board?",
        URL_SEARCH_IMPACT_STORIES: "/wp-json/phi/v1/search_impact_stories?",
        URL_SEARCH_NEWS: "/wp-json/phi/v1/search_news?",
        URL_SEARCH_STATE_DEVELOPMENTS:
            "/wp-json/phi/v1/search_state_developments?",
        URL_SEARCH_OPINION: "/wp-json/phi/v1/search_opinion?",
        URL_SEARCH_RESOURCES: "/wp-json/phi/v1/search_resources?",
        URL_SEARCH_RESOURCE_CENTER: "/wp-json/phi/v1/resource_center/?",
        URL_SEARCH: "/wp-json/phi/v1/search/?",
        DEBUG: true,
        handleReturn: function (d) {
            if (d) {
                if (d.success) {
                    return true;
                } else {
                    if (d.message) {
                        alert(d.message);
                    } else {
                        alert("There was a problem processing your request.");
                    }
                }
            }

            return false;
        },
        getCaseStudies: function (
            keyword,
            from,
            to,
            service,
            state,
            offset,
            callback
        ) {
            keyword = keyword ? $.trim(keyword) : "";
            service = service ? $.trim(service) : null;
            from = from ? $.trim(from) : null;
            to = to ? $.trim(to) : null;
            state = state ? $.trim(state) : null;
            offset = parseInt(offset ? $.trim(offset) : "0", 10);

            if (isNaN(offset)) {
                offset = 0;
            }

            var params = [];

            if (keyword.length > 2)
                params.push("search=" + encodeURIComponent(keyword));

            if (service) params.push("service=" + encodeURIComponent(service));

            if (from) params.push("from=" + encodeURIComponent(from));

            if (to) params.push("to=" + encodeURIComponent(to));

            if (state) params.push("state=" + encodeURIComponent(state));

            params.push("offset=" + offset);
            params.push("page_size=" + PHI.api.PAGE_SIZE);

            if (PHI.api.DEBUG) params.push("debug=1");

            _invoke(
                PHI.api.URL_SEARCH_CASE_STUDIES + params.join("&"),
                null,
                callback
            );
        },
        getExperts: function (keyword, expertise, offset, callback) {
            keyword = keyword ? $.trim(keyword) : "";
            expertise = expertise ? $.trim(expertise) : null;
            offset = parseInt(offset ? $.trim(offset) : "0", 10);

            if (isNaN(offset)) {
                offset = 0;
            }

            var params = [];

            if (keyword.length > 2)
                params.push("search=" + encodeURIComponent(keyword));

            if (expertise)
                params.push("expertise=" + encodeURIComponent(expertise));

            params.push("offset=" + offset);
            params.push("page_size=" + PHI.api.PAGE_SIZE_EXPERTS);

            if (PHI.api.DEBUG) params.push("debug=1");

            _invoke(
                PHI.api.URL_SEARCH_EXPERTS + params.join("&"),
                null,
                callback
            );
        },
        getBoard: function (offset, callback) {
            offset = parseInt(offset ? $.trim(offset) : "0", 10);

            if (isNaN(offset)) {
                offset = 0;
            }

            var params = [];

            params.push("offset=" + offset);
            params.push("page_size=1024");

            if (PHI.api.DEBUG) params.push("debug=1");

            _invoke(
                PHI.api.URL_SEARCH_BOARD + params.join("&"),
                null,
                callback
            );
        },
        getImpactStories: function (
            keyword,
            from,
            to,
            service,
            state,
            offset,
            callback
        ) {
            keyword = keyword ? $.trim(keyword) : "";
            service = service ? $.trim(service) : null;
            from = from ? $.trim(from) : null;
            to = to ? $.trim(to) : null;
            state = state ? $.trim(state) : null;
            offset = parseInt(offset ? $.trim(offset) : "0", 10);

            if (isNaN(offset)) {
                offset = 0;
            }

            var params = [];

            if (keyword.length > 2)
                params.push("search=" + encodeURIComponent(keyword));

            if (service) params.push("service=" + encodeURIComponent(service));

            if (from) params.push("from=" + encodeURIComponent(from));

            if (to) params.push("to=" + encodeURIComponent(to));

            if (state) params.push("state=" + encodeURIComponent(state));

            params.push("offset=" + offset);
            params.push("page_size=" + PHI.api.PAGE_SIZE);

            if (PHI.api.DEBUG) params.push("debug=1");

            _invoke(
                PHI.api.URL_SEARCH_IMPACT_STORIES + params.join("&"),
                null,
                callback
            );
        },
        getNews: function (
            keyword,
            type,
            from,
            to,
            issue,
            service,
            state,
            offset,
            callback
        ) {
            keyword = keyword ? $.trim(keyword) : "";
            type = type ? $.trim(type) : null;
            from = from ? $.trim(from) : null;
            to = to ? $.trim(to) : null;
            issue = issue ? $.trim(issue) : null;
            service = service ? $.trim(service) : null;
            state = state ? $.trim(state) : null;
            offset = parseInt(offset ? $.trim(offset) : "0", 10);

            if (isNaN(offset)) {
                offset = 0;
            }

            var params = [];

            if (keyword.length > 2)
                params.push("search=" + encodeURIComponent(keyword));

            if (type) params.push("type=" + encodeURIComponent(type));

            if (from) params.push("from=" + encodeURIComponent(from));

            if (to) params.push("to=" + encodeURIComponent(to));

            if (issue) params.push("issue=" + encodeURIComponent(issue));

            if (service) params.push("service=" + encodeURIComponent(service));

            if (state) params.push("state=" + encodeURIComponent(state));

            params.push("offset=" + offset);
            params.push("page_size=" + PHI.api.PAGE_SIZE);

            if (PHI.api.DEBUG) params.push("debug=1");

            _invoke(PHI.api.URL_SEARCH_NEWS + params.join("&"), null, callback);
        },
        getStateDevelopments: function (
            keyword,
            from,
            to,
            issue,
            service,
            state,
            offset,
            callback
        ) {
            keyword = keyword ? $.trim(keyword) : "";
            from = from ? $.trim(from) : null;
            to = to ? $.trim(to) : null;
            issue = issue ? $.trim(issue) : null;
            service = service ? $.trim(service) : null;
            state = state ? $.trim(state) : null;
            offset = parseInt(offset ? $.trim(offset) : "0", 10);

            if (isNaN(offset)) {
                offset = 0;
            }

            var params = [];

            if (keyword.length > 2)
                params.push("search=" + encodeURIComponent(keyword));

            if (from) params.push("from=" + encodeURIComponent(from));

            if (to) params.push("to=" + encodeURIComponent(to));

            if (issue) params.push("issue=" + encodeURIComponent(issue));

            if (service) params.push("service=" + encodeURIComponent(service));

            if (state) params.push("state=" + encodeURIComponent(state));

            params.push("offset=" + offset);
            params.push("page_size=" + PHI.api.PAGE_SIZE);

            if (PHI.api.DEBUG) params.push("debug=1");

            _invoke(
                PHI.api.URL_SEARCH_STATE_DEVELOPMENTS + params.join("&"),
                null,
                callback
            );
        },
        getOpinion: function (
            keyword,
            from,
            to,
            issue,
            service,
            state,
            offset,
            callback
        ) {
            keyword = keyword ? $.trim(keyword) : "";
            from = from ? $.trim(from) : null;
            to = to ? $.trim(to) : null;
            issue = issue ? $.trim(issue) : null;
            service = service ? $.trim(service) : null;
            state = state ? $.trim(state) : null;
            offset = parseInt(offset ? $.trim(offset) : "0", 10);

            if (isNaN(offset)) {
                offset = 0;
            }

            var params = [];

            if (keyword.length > 2)
                params.push("search=" + encodeURIComponent(keyword));

            if (from) params.push("from=" + encodeURIComponent(from));

            if (to) params.push("to=" + encodeURIComponent(to));

            if (issue) params.push("issue=" + encodeURIComponent(issue));

            if (service) params.push("service=" + encodeURIComponent(service));

            if (state) params.push("state=" + encodeURIComponent(state));

            params.push("offset=" + offset);
            params.push("page_size=" + PHI.api.PAGE_SIZE);

            if (PHI.api.DEBUG) params.push("debug=1");

            _invoke(
                PHI.api.URL_SEARCH_OPINION + params.join("&"),
                null,
                callback
            );
        },
        getResources: function (
            keyword,
            type,
            issue,
            from,
            to,
            expert,
            state,
            phi_authored,
            offset,
            callback
        ) {
            keyword = keyword ? $.trim(keyword) : "";
            type = type ? $.trim(type) : null;
            issue = issue ? $.trim(issue) : null;
            expert = expert ? $.trim(expert) : null;
            state = state ? $.trim(state) : null;
            offset = parseInt(offset ? $.trim(offset) : "0", 10);

            if (isNaN(offset)) {
                offset = 0;
            }

            var params = [];

            if (keyword.length > 2)
                params.push("search=" + encodeURIComponent(keyword));

            if (type) params.push("type=" + encodeURIComponent(type));

            if (issue) params.push("issue=" + encodeURIComponent(issue));

            if (expert) params.push("expert=" + encodeURIComponent(expert));

            if (state) params.push("state=" + encodeURIComponent(state));

            if (phi_authored !== null && phi_authored)
                params.push("phi_authored=" + phi_authored);

            params.push("offset=" + offset);
            params.push("page_size=" + PHI.api.PAGE_SIZE);

            if (PHI.api.DEBUG) params.push("debug=1");

            _invoke(
                PHI.api.URL_SEARCH_RESOURCES + params.join("&"),
                null,
                callback
            );
        },
        getWorkers: function (state, ocсupation, topic, offset, callback) {
            state = state ? $.trim(state) : "";
            ocсupation = ocсupation ? $.trim(ocсupation) : null;
            topic = topic ? $.trim(topic) : null;
            offset = parseInt(offset ? $.trim(offset) : "0", 10);

            if (isNaN(offset)) {
                offset = 0;
            }

            var params = [];
            if (state) params.push("state=" + encodeURIComponent(state));

            if (oсcupation)
                params.push("ocсupation=" + encodeURIComponent(ocсupation));

            if (topic) params.push("topic=" + encodeURIComponent(topic));

            params.push("offset=" + offset);
            params.push("page_size=" + PHI.api.PAGE_SIZE);

            if (PHI.api.DEBUG) params.push("debug=1");

            _invoke(
                PHI.api.URL_SEARCH_RESOURCES + params.join("&"),
                null,
                callback
            );
        },

        search: function (
            search,
            type,
            service,
            from,
            to,
            expert,
            state,
            issue,
            client,
            partner,
            offset,
            callback
        ) {
            search = search ? $.trim(search) : "";
            type = type ? $.trim(type) : "";
            service = service ? $.trim(service) : null;
            from = from ? $.trim(from) : null;
            to = to ? $.trim(to) : null;
            expert = expert ? $.trim(expert) : null;
            state = state ? $.trim(state) : null;
            issue = issue ? $.trim(issue) : null;
            client = client ? $.trim(client) : null;
            partner = issue ? $.trim(partner) : null;
            offset = parseInt(offset ? $.trim(offset) : "0", 10);

            if (isNaN(offset)) {
                offset = 0;
            }

            var params = [];

            if (search.length > 2)
                params.push("search=" + encodeURIComponent(search));

            if (type) params.push("type=" + encodeURIComponent(type));

            if (service) params.push("service=" + encodeURIComponent(service));

            if (from) params.push("from=" + encodeURIComponent(from));

            if (to) params.push("to=" + encodeURIComponent(to));

            if (expert) params.push("expert=" + encodeURIComponent(expert));

            if (state) params.push("state=" + encodeURIComponent(state));

            if (issue) params.push("issue=" + encodeURIComponent(issue));

            if (client) params.push("client=" + encodeURIComponent(client));

            if (partner) params.push("partner=" + encodeURIComponent(partner));

            params.push("offset=" + offset);
            params.push("page_size=" + PHI.api.PAGE_SIZE);

            if (PHI.api.DEBUG) params.push("debug=1");

            _invoke(PHI.api.URL_SEARCH + params.join("&"), null, callback);
        },

        getResourceCenter: (options = {}, callback) => {
            var params = [];
            options.offset = options.offset ? options.offset : 0;
            options.page_size = options.page_size ? options.page_size : 10;
            Object.keys(options).forEach((key) =>
                params.push(key + "=" + encodeURIComponent(options[key]))
            );
            if (PHI.api.DEBUG) params.push("debug=1");

            _invoke(
                PHI.api.URL_SEARCH_RESOURCE_CENTER + params.join("&"),
                null,
                callback
            );
        },
    };

    PHI.google = {
        trackOutbound: function (e) {
            // bail if no google analytics
            if (!gtag) {
                return;
            }

            var who = e.currentTarget;

            if (
                (who.hostname &&
                    who.hostname !== "#" &&
                    who.hostname !== window.location.hostname &&
                    who.hostname !== "wordpress.org") ||
                "mailto:" === who.protocol
            ) {
                gtag("event", "click", {
                    event_category: "Outbound Link",
                    event_label: who.href,
                    value: 1,
                    transport_type: "beacon",
                });
            }
        },
    };

    PHI.Pager = function () {
        var PAGES_TO_SHOW = 5,
            _offset = 0,
            _page = 1,
            _totalPages = 0,
            _container = null,
            _anchor = null,
            _callback = null;

        this.offset = function () {
            return _offset;
        };

        this.reset = function () {
            _offset = 0;
            _page = 1;
            _totalPages = 0;
        };

        this.init = function (pagerSelector, anchorSelector, pagingCallback) {
            this.reset();

            if (!pagerSelector) throw "pageSelector is required";

            if (!pagingCallback) throw "pagingCallback is required";

            _container = $(pagerSelector);

            if (anchorSelector) {
                _anchor = $(anchorSelector);

                if (0 === _anchor.length) _anchor = null;
            }

            _callback = pagingCallback;
        };

        function _goto(who) {
            var page = $(who).data("page");

            _page = page;
            _offset = (_page - 1) * PHI.api.PAGE_SIZE;

            if (_anchor) {
                $("html,body").animate(
                    {
                        scrollTop: _anchor.offset().top - 64,
                    },
                    250,
                    function () {
                        _callback({
                            type: "pagination",
                            target: who,
                        });
                    }
                );

                return;
            }

            _callback({
                type: "pagination",
                target: who,
            });
        }

        this.render = function (total_found, page_size) {
            if (total_found != 0) {
                _totalPages = Math.ceil(
                    total_found / (page_size ? page_size : PHI.api.PAGE_SIZE)
                );
            } else {
                _totalPages = 0;
            }

            $(".list-page-pagination-nav").unbind("click");

            _container.empty();

            if (0 === total_found) return;

            if (1 === _totalPages) return;

            var showNav = _totalPages > PAGES_TO_SHOW,
                startPage = 1;

            while (startPage <= _totalPages) {
                if (_page < startPage + PAGES_TO_SHOW) break;

                if (_page === startPage) break;

                startPage += PAGES_TO_SHOW;
            }

            var endPage = Math.min(_totalPages, startPage + PAGES_TO_SHOW - 1);

            if (endPage === _totalPages)
                startPage = Math.max(1, endPage - PAGES_TO_SHOW + 1);

            var jumpPrevPage = Math.max(1, startPage - PAGES_TO_SHOW),
                jumpNextPage = Math.min(_totalPages, startPage + PAGES_TO_SHOW);

            if (showNav) {
                _container.append(
                    $(
                        '<a class="list-page-pagination-nav list-page-pagination-nav-first" href="#" data-page="1" title="First Page"><img src="/wp-content/themes/phi/assets/images/page-first.svg" alt="First Page"/></a>'
                    )
                );
                _container.append(
                    $(
                        '<a class="list-page-pagination-nav list-page-pagination-nav-prev" href="#" data-page="' +
                            jumpPrevPage +
                            '" title="Previous 5"><img src="/wp-content/themes/phi/assets/images/page-previous.svg" alt="Previous 5"/></a>'
                    )
                );
            }

            var a = null;

            for (var p = startPage; p <= endPage; p++) {
                a = $(
                    '<a class="list-page-pagination-nav list-page-pagination-nav-page" href="#" data-page="' +
                        p +
                        '" title="Go to page ' +
                        p +
                        '">' +
                        p +
                        "</a>"
                );

                if (p === _page)
                    a.addClass("list-page-pagination-nav--selected");

                _container.append(a);
            }

            if (showNav) {
                _container.append(
                    $(
                        '<a class="list-page-pagination-nav list-page-pagination-nav-next" href="#" data-page="' +
                            jumpNextPage +
                            '" title="Next 5"><img src="/wp-content/themes/phi/assets/images/page-next.svg" alt="Next 5"/></a>'
                    )
                );
                _container.append(
                    $(
                        '<a class="list-page-pagination-nav list-page-pagination-nav-last" href="#" data-page="' +
                            _totalPages +
                            '" title="Last Page"><img src="/wp-content/themes/phi/assets/images/page-last.svg" alt="Last Page"/></a>'
                    )
                );
            }

            $(".list-page-pagination-nav").click(function (e) {
                e.preventDefault();

                _goto($(this));
            });
        };

        return this;
    };
})(jQuery);
